import React from "react";
import DarkModeSwitcherPart from "./DarkModeSwitcher.part";
import { AsideFooter } from "../../../components/admin/layouts/Aside/Aside";
import UserTemplate from "../User/User.template";
import classNames from "classnames";
import useAsideStatus from "../../../hooks/useAsideStatus";
import Icon from "../../../components/icon/Icon";
import { useNavigate } from "react-router-dom";

const AsideFooterPart = () => {
  const { asideStatus } = useAsideStatus();
  const navigate = useNavigate();
  return (
    <AsideFooter>
      <div
        className={classNames(
          "mb-2 p-3 flex items-center cursor-pointer overflow-hidden rounded-xl border border-zinc-300 hover:border-zinc-950 dark:hover:border-zinc-100 grow justify-center text-zinc-400 hover:text-zinc-950 dark:hover:text-zinc-100"
        )}
        onClick={() => navigate("/")}
      >
        {!asideStatus ? <Icon icon={"HeroArrowUturnLeft"} /> : "Return To Site"}
      </div>
      <UserTemplate />
      <DarkModeSwitcherPart />
    </AsideFooter>
  );
};

export default AsideFooterPart;
